import { render } from "./PrincipalWorkspaceClientComponent.vue?vue&type=template&id=98c173c2&scoped=true"
import script from "./PrincipalWorkspaceClientComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalWorkspaceClientComponent.vue?vue&type=script&lang=js"

import "./PrincipalWorkspaceClientComponent.vue?vue&type=style&index=0&id=98c173c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c173c2"]])

export default __exports__